import { batch } from '@tmapy/redux';
import { MAP_TOOL, LAYER_IDS, LAYER_TYPE } from '@tmapy/config';
import { actionSetLayerFeatures, INTERACTION_MODIFY_FEATURES, MAP_CLICK, SET_LAYER_FEATURES, SET_LAYER_FEATURE_HIGHLIGHT, SET_INTERACTION, } from '@tmapy/mapcore';
import { actionSetMapTool } from '@tmapy/ui-manager';
import { actionReverseLine } from './actions/reverseLine';
import { actionSelectFeature } from './actions/selectFeature';
import { actionIntersection } from './actions/intersection';
import { actionCreateIntersectionPoint } from './actions/createIntersectionPoint';
import { actionLoadFeaturesForEdit } from './actions/loadFeaturesForEdit';
import { actionSaveEditedFeatures } from './actions/saveEditedFeature';
import { actionMultiLineStringSplitAndSave } from './actions/actionMultiLineStringSplitAndSave';
import { actionCreateLineSplitPoint } from './actions/actionCreateLineSplitPoint';
import { actionDeleteAndSaveFeature } from './actions/actionDeleteAndSaveFeature';
import { actionDeactivateTools } from './actions/deactivateTool';
import { actionSelectFeatureInput } from './actions/actionSelectFeatureInput';
import { actionUnhideTileAllFeaturesByLayer } from './actions';
export const editToolsMiddleware = (store) => (next) => (action) => {
    return batch(() => {
        const originalAction = next(action);
        const state = store.getState();
        const activeMapTool = state.uiManager.activeMapTool;
        switch (action.type) {
            case SET_LAYER_FEATURE_HIGHLIGHT: {
                // clean after feature loaded and unhighlight
                const loadedFeatures = state.editTools.loadedFeatures;
                if (!action.payload.highlightedFeatures.length && loadedFeatures.length) {
                    loadedFeatures.forEach((feature) => {
                        store.dispatch(actionUnhideTileAllFeaturesByLayer(LAYER_IDS.EDIT_TOOLS_HIGHLIGHT, feature.layerId));
                    });
                }
                const isVectorTileInHighlightedFeatures = action.payload.highlightedFeatures.some((highlightedFeature) => state.mapCore.layers.some((layer) => layer.id === highlightedFeature.layerId && layer.type === LAYER_TYPE.TILE_VECTOR));
                if (isVectorTileInHighlightedFeatures) {
                    store.dispatch(actionLoadFeaturesForEdit(action.payload, action.meta));
                }
                const highlightedFeature = action.payload.highlightedFeatures.find((highlightedFeature) => highlightedFeature.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT &&
                    highlightedFeature.featureId);
                if (state.editTools.intersectionInteraction.isActive && highlightedFeature) {
                    store.dispatch(actionCreateIntersectionPoint(highlightedFeature, action.payload.coordinate));
                }
                if (activeMapTool === MAP_TOOL.SPLIT_LINE) {
                    store.dispatch(actionCreateLineSplitPoint(highlightedFeature, action.payload.coordinate));
                }
                return originalAction;
            }
            case INTERACTION_MODIFY_FEATURES: {
                store.dispatch(actionSaveEditedFeatures(action.payload));
                return originalAction;
            }
            case MAP_CLICK: {
                if (activeMapTool === MAP_TOOL.REVERSE_LINE) {
                    store.dispatch(actionReverseLine(action.payload));
                }
                else if (activeMapTool === MAP_TOOL.INFOEDIT) {
                    const features = action.payload.features;
                    features.length && store.dispatch(actionSelectFeature({ features, edit: false }));
                }
                else if (state.editTools.intersectionInteraction.isActive) {
                    if (activeMapTool === MAP_TOOL.INTERSECTION_SPLIT_LINE) {
                        store.dispatch(actionMultiLineStringSplitAndSave(action.payload));
                    }
                    else {
                        store.dispatch(actionIntersection(action.payload));
                    }
                }
                else if (activeMapTool === MAP_TOOL.SPLIT_LINE) {
                    store.dispatch(actionMultiLineStringSplitAndSave(action.payload));
                }
                else if (activeMapTool === MAP_TOOL.DELETE) {
                    store.dispatch(actionDeleteAndSaveFeature(action.payload));
                }
                else if (activeMapTool === MAP_TOOL.SELECT_FEATURE) {
                    store.dispatch(actionSelectFeatureInput(action.payload.features));
                }
                return originalAction;
            }
            case SET_LAYER_FEATURES: {
                if (state.editTools.intersectionInteraction.isActive &&
                    action.payload.layerId === LAYER_IDS.EDIT_TOOLS_HIGHLIGHT) {
                    store.dispatch(actionSetLayerFeatures(LAYER_IDS.EDIT_TOOLS_SNAP, []));
                }
                return originalAction;
            }
            case SET_INTERACTION: {
                if (action.meta?.activateDrawTool === false) {
                    store.dispatch(actionDeactivateTools());
                }
                else if (action.meta?.activateDrawTool === true) {
                    // activate drawind tool
                    store.dispatch(actionDeactivateTools());
                    store.dispatch(actionSetMapTool(MAP_TOOL.DRAW));
                    return store.dispatch({
                        ...action,
                        payload: {
                            ...action.payload,
                            layerId: LAYER_IDS.EDIT_TOOLS_MODIFY,
                            highlightedFeatures: [],
                            highlightedFeaturesCount: 0, // zadna
                        },
                        meta: undefined,
                    });
                }
                return originalAction;
            }
            default: {
                return originalAction;
            }
        }
    });
};
//# sourceMappingURL=editToolsMiddleware.js.map